import type { FC, PropsWithChildren, ReactElement, Dispatch } from 'react';
import { createContext, useContext, useMemo, useReducer } from 'react';

import { LauncherAction } from './actions';
import { launcherReducer } from './reducer';
import type { LauncherState } from './types';

export interface LauncherContextType extends LauncherState {
  dispatch: Dispatch<LauncherAction>;
}

const defaultValue: LauncherState = {
  tables: [],
  enableMultiTable: false,
  showFullscreen: false,
};

const LauncherContext = createContext<LauncherContextType>({
  ...defaultValue,
  dispatch: () => {},
});

export const LauncherContextProvider: FC<PropsWithChildren> = ({ children }): ReactElement => {
  const [state, dispatch] = useReducer(launcherReducer, defaultValue);
  const contextValue = useMemo(() => ({ ...state, dispatch }), [state]);
  return <LauncherContext.Provider value={contextValue}>{children}</LauncherContext.Provider>;
};

export const useLauncherContext = (): LauncherContextType => useContext(LauncherContext);
